<script lang="ts" setup>
	import type { ICloudflareImage } from "~/server/models/mixins/cloudflareImage";

	const {
		public: { cloudflare },
	} = useRuntimeConfig();

	const props = withDefaults(
		defineProps<{
			value: ICloudflareImage;
			width: number;
			height?: number;
			alt?: string;
			fit?: "scale-down" | "cover";
			density?: number;
		}>(),
		{
			fit: "scale-down",
			density: 2,
		}
	);

	type Keys = {
		width?: number;
		height?: number;
		fit: "scale-down" | "cover";
		dpr: number;
	};

	function getUrl(id: string) {
		const params: Keys = {
			fit: props.fit,
			dpr: props.density,
		};

		if (props.width) params.width = props.width;
		if (props.height) params.height = props.height;

		//

		const query: string = Object.keys(params)
			.map((key) => {
				return `${key}=${(params as any)[key]}`;
			})
			.join(",");

		return `https://imagedelivery.net/${cloudflare.accountHash}/${id}/${query}`;
	}

	const src = computed(() => {
		return getUrl(props.value.id);
	});
</script>

<template>
	<img loading="lazy" decoding="async" class="cloudflare-image" :src="src" :alt="props.alt" />
</template>

<style scoped lang="scss">
	.cloudflare-image {
		background: var(--beige-light);
		background-size: cover;
		background-position: center center;
		object-fit: cover;
		object-position: center center;
	}
</style>
